import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { Spinner } from "@/components/ui/spinner";
import { store_collection_path } from "@/lib/routes";
import { AdminPageProps, Collection } from "@/types";
import { SheetProps } from "@/types/ui";
import { useForm, usePage } from "@inertiajs/react";
import { FormEvent } from "react";
import useTranslations from "@/hooks/use-translations";
import CollectionForm, { CollectionFormData } from "./collection-form";

export default function EditCollectionSheet({
  collection,
  open,
  onOpenChange,
}: SheetProps & { collection: Collection }) {
  const { current_store } = usePage<AdminPageProps>().props;
  const { t } = useTranslations("shared.components.edit_collection_sheet");

  const editCollectionForm = useForm<CollectionFormData>({
    collection: {
      name: collection.name,
      state: collection.state,
      products: collection.products,
      product_ids: collection.products.map((product) => product.id),
    },
  });

  function onSubmit(event: FormEvent) {
    event.preventDefault();

    editCollectionForm.patch(
      store_collection_path(current_store!, collection),
      {
        invalidateCacheTags: ["stores", current_store?.id ?? ""],
        onSuccess() {
          editCollectionForm.resetAndClearErrors();
          onOpenChange(false);
        },
      }
    );
  }

  return (
    <>
      <Sheet open={open} onOpenChange={onOpenChange}>
        <SheetContent>
          <SheetHeader>
            <SheetTitle>{t("title")}</SheetTitle>
          </SheetHeader>

          <CollectionForm
            collection={collection}
            form={editCollectionForm}
            onSubmit={onSubmit}
          />

          <SheetFooter>
            <Button
              type="submit"
              form={`edit-collection-form-${collection.id}`}
              disabled={editCollectionForm.processing}
            >
              {editCollectionForm.processing && <Spinner />}
              {t("shared.actions.save")}
            </Button>
            <SheetClose asChild>
              <Button
                variant="outline"
                disabled={editCollectionForm.processing}
              >
                {t("shared.actions.close")}
              </Button>
            </SheetClose>
          </SheetFooter>
        </SheetContent>
      </Sheet>
    </>
  );
}
